<div *ngIf="component != 'carousel'">
    <bgl-slot-races></bgl-slot-races>
</div>
<div *ngIf="component == 'carousel'">
    <vn-message-panel></vn-message-panel>
    <bgl-slot-races-cards class="bgl-slot-races-cards" [showPlaceholderCard]="true" [addUpcoming]="true" [fromBingoHomepage]="fromBingoHomepage">
    </bgl-slot-races-cards>
</div>
